import { trendingTopics } from '@/mocks/home';

const rankStyles = [
  'bg-primary-500 text-background-50',
  'bg-primary-400 text-background-50',
  'bg-accent-500 text-secondary-950',
];

export default function TrendingSection() {
  return (
    <section id="trending" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-8">
            <div className="flex items-end justify-between gap-4 mb-8">
              <div>
                <p className="text-xs tracking-[0.3em] text-primary-600 font-medium mb-2">
                  HOT TOPICS
                </p>
                <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
                  今日热议话题
                </h2>
              </div>
              <a
                href="#categories"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                全部分类
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>

            <ol className="divide-y divide-background-200/70 border-t border-background-200/70">
              {trendingTopics.map((topic) => (
                <li key={topic.id}>
                  <a
                    href="#articles"
                    className="group flex items-start gap-4 md:gap-5 py-5 hover:bg-background-100/60 transition-colors px-2 -mx-2 rounded-md"
                  >
                    <span
                      className={`shrink-0 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-md font-heading font-black text-sm ${
                        rankStyles[topic.rank - 1] ??
                        'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {topic.rank}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="flex items-center gap-2 flex-wrap">
                        <span className="font-heading font-bold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                          {topic.title}
                        </span>
                        {topic.isNew && (
                          <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-800 text-[10px] font-medium whitespace-nowrap">
                            新
                          </span>
                        )}
                      </span>
                      <span className="mt-1.5 block text-xs md:text-sm text-foreground-600 leading-relaxed">
                        {topic.summary}
                      </span>
                    </span>
                    <span className="shrink-0 hidden sm:flex flex-col items-end gap-1.5">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap">
                        {topic.category}
                      </span>
                      <span className="flex items-center gap-1 text-xs text-primary-600">
                        <i className="ri-fire-line" aria-hidden="true"></i>
                        {topic.heat}
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 bg-secondary-50 border border-secondary-200/70 rounded-lg p-6">
              <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                <i className="ri-lightbulb-line text-secondary-600" aria-hidden="true"></i>
                榜单怎么看
              </h3>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                热议榜单综合话题的讨论量、阅读量与瓜友互动情况实时计算，越多人参与的话题越靠前。
              </p>
              <ul className="mt-5 space-y-3">
                {[
                  { icon: 'ri-fire-line', text: '数值为近 24 小时讨论热度' },
                  { icon: 'ri-refresh-line', text: '榜单每小时刷新一次排序' },
                  { icon: 'ri-shield-check-line', text: '未核实信息会标注「待核实」' },
                ].map((row) => (
                  <li key={row.text} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                      <i className={row.icon} aria-hidden="true"></i>
                    </span>
                    <span className="leading-relaxed pt-1">{row.text}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#community"
                className="mt-6 flex items-center justify-center gap-2 w-full h-11 rounded-md bg-secondary-600 hover:bg-secondary-700 text-background-50 text-sm font-medium transition-colors cursor-pointer"
              >
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                去瓜友交流区聊聊
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}